'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthenticationPolicySection, loginEmailPoliciesQueryOptions, loginMethodPoliciesQueryOptions, mfaSettingsQueryOptions } from '@/features/identity-policy';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { queryClient } from '@/lib/queryClient';
export const Route = createFileRoute('/_staff/idp/_layout/settings/authentication-method/')({
  loader: async () => {
    await Promise.all([queryClient.ensureQueryData(mfaSettingsQueryOptions()), queryClient.ensureQueryData(loginEmailPoliciesQueryOptions()), queryClient.ensureQueryData(loginMethodPoliciesQueryOptions())]);
  },
  component: IdpAuthenticationMethodPage
});
function IdpAuthenticationMethodPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.idp.settings.authenticationMethod'
  });
  return <AuthenticationPolicySection title={t('title')} description={t('description')} />;
}